import * as angular from 'angular';

import { ComponentDefinition, KeyValuePair, ScriptType } from '../../models';

class LibraryMultiSelectController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    model: string[];
    
    readonly libraries: KeyValuePair<string, string>[];
    readonly type: ScriptType;

    static $inject = ['$state'];
    constructor(
        private _$state: angular.ui.IStateService,
    ) {
    }

    click(item: { key: string; value: string }) {
        this._$state.go('fileManagement', { type: this.type, file: `${item.value}.py` });
    }
}

export const wtLibraryMultiSelect: ComponentDefinition = {
    componentId: 'wtLibraryMultiSelect',
    controller: LibraryMultiSelectController,
    template: require('./libraryMultiSelect.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        libraries: '<',
        type: '<'
    }
};